var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:{'app-form-section': true, 'no-margin': _vm.noMargin},attrs:{"flat":"","rounded":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }